import Container from 'common/components/Container';
import {
  PrincingPageHeader,
  ContainerSwitchSubcription,
  Princing,
  Description,
} from './pricingPage.style';
import STGradiantToggle from 'common/STGradiantToggle/STGradiantToggle';
import { useEffect, useState } from 'react';
import PurchaseCredit from './PurchaseCredit/PurchaseCredit';
import SubscriptionPlans from './SubscriptionPlans/SubscriptionPlans';
import TokenUsage from './TokenUsage/TokenUsage';
import { Box, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import useSubscriptionPlans from 'hooks/useSubscriptionPlans';
import { useRouter } from 'next/router';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import { saasModernTheme } from 'common/theme/saasModern';
import BtnContact from 'common/components/Button/BTNContact';
import BtnGetStarted from 'common/components/Button/BTNGetStarted';
import PricingFeatureDefault from './PricingTable/PricingFeature';


const PricingPage = ({ locale, data }) => {
  const { query, push } = useRouter();
  const { t } = useTranslations();

  const defaultValue = query.tab || '';
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const { subplans, togglePlanType } = useSubscriptionPlans(defaultValue);

  const toggleData = [
    { value: 'SOLO', label: t('pricing.solo') },
    { value: 'TEAM', label: t('pricing.team') },
    { value: 'CREDIT', label: t('pricing.credit') },
  ];
  const [dataPricings, setDataPricings] = useState(null);
  const [plans, setPlans] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchPricingData = async () => {
      const isEnterprise = query?.tab === 'SOLO';
      const pricingUrl = `https://graphql.swiftask.ai/public/sub_plans_details?isYearly=false&isEnterprise=${isEnterprise}`;
      try {
        const res = await fetch(pricingUrl);
        const json = await res.json();
        setDataPricings(json);
        setPlans(json.plans || []);
        setCategories(json.categories || []);
      } catch (err) {
        console.error('Erreur lors du chargement des données de pricing:', err);
      }
    };

    if (query.tab) {
      fetchPricingData();
    }
  }, [query.tab]);
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      if (newValue !== 'CREDIT') {
        togglePlanType(newValue);
      }
      setSelectedValue(newValue);
      push(
        {
          pathname: '/pricing',
          query: { tab: newValue },
        },
        undefined,
        { shallow: true },
      );
    }
  };

  useEffect(() => {
    if (query.tab) {
      handleChange(null, query.tab);
    }
  }, [query.tab]);

  return (
    <>
      <Container>
        <PrincingPageHeader>
          <PrismicRichText
            field={data.title}
            components={{
              paragraph: ({ children }) => (
                <Typography
                  variant="h1"
                  sx={{
                    width: ['100%', '100%', '80%'],
                    fontSize: ['40px', '44px', '64px'],
                    marginTop: ['10px', '0', '85px'],
                    fontFamily: saasModernTheme.fontFamily,
                    lineHeight: ['45px', '65px'],
                    fontWeight: 800,
                    '.font-semibold': {
                      background:
                        saasModernTheme.customColor.inversGradiantColor,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    },
                  }}
                >
                  {children}
                </Typography>
              ),
            }}
          />
          <Description>{data.description_title}</Description>
          <Box
            sx={{
              marginBottom: ['50px', '80px'],
              marginTop: ['10px', '20px'],
            }}
          >
            <BtnContact label={data.btncta} locale={locale} />
          </Box>
        </PrincingPageHeader>
        <ContainerSwitchSubcription
          role="region"
          aria-labelledby="subscription"
        >
          <STGradiantToggle
            value={selectedValue}
            exclusive
            size="large"
            onChange={handleChange}
            toggleData={toggleData}
          />
        </ContainerSwitchSubcription>

        <Box
          sx={{
            display: 'flex',
            gap: 3,
            mt: 4,
            width: '100',
            flexWrap: ['wrap', 'nowrap'],
          }}
        >
          {selectedValue == 'CREDIT' ? (
            <PurchaseCredit data={data} />
          ) : (
            <SubscriptionPlans
              subplans={subplans}
              selectedValue={selectedValue}
            />
          )}
        </Box>

        <TokenUsage
          subPlansTokenUsage={data.subPlansTokenUsage}
          botsUseCaseLabel={data.botsUseCaseLabel}
          locale={locale}
        />
          <PricingFeatureDefault
            detailUrl = {selectedValue}
            plans={plans}
            categories={categories}
            locale={locale}
          />
        <Princing>
          <PrismicRichText
            field={data.buyingcredittitle}
            components={{
              paragraph: ({ children }) => (
                <Typography
                  variant="h2"
                  sx={{
                    width: '80%',
                    fontSize: ['30px', '48px'],
                    fontFamily: saasModernTheme.fontFamily,
                    lineHeight: ['45px', '65px'],
                    margin: '50px 0 30px 0',

                    fontWeight: 800,
                    '.font-semibold': {
                      background: saasModernTheme.customColor.gradiantColor,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    },
                  }}
                >
                  {children}
                </Typography>
              ),
            }}
          />

          <BtnGetStarted label={data.buying_credits_button} />
        </Princing>
      </Container>
    </>
  );
};

export default PricingPage;
